import { State } from "./types";
/*
 * define state here
 */
export default (): State => ({
  results: [],
  count: 0, //total rows
  next: null,
  previous: null,
});
